<template>
  <div class="location-body">
    <template v-for="(item,index) in iconList">
      <div class="location-item" v-if="item" :key="index" @click.stop="toLink(item.link)">
        <img class="icon-hot" v-if="tooltipsObj[item.tooltipsKey]" :src="tooltipsObj[item.tooltipsKey].image" alt="">
        <img class="location-icon" :src="item.image" alt="">
        <div>{{item.title}}</div>
      </div>
    </template>

  </div>
</template>

<script>
import api from "@/api/api-list";
import {loginMixin, envMixin} from  '@/assets/js/mixin/global'
export default {
  mixins: [loginMixin, envMixin],
  name:'goodLocation',
  props: {

  },
  created(){
    this.getGoodLocaltion()
    this.getTooltips()
  },
  data(){
   return {
     hotImg: 'https://files.wondercv.com/cvs/isHot.gif',
     iconList: [
     ],
     tooltipsObj: {}
   }
  },
  methods:{
    // 获取金刚位气泡
    getTooltips() {
      let tooltip1 = api.jobs.getBannerImg({position: 122})
      let tooltip2 = api.jobs.getBannerImg({position: 123})
      let tooltip3 = api.jobs.getBannerImg({position: 124})
      let tooltip4 = api.jobs.getBannerImg({position: 125})
      try {
        Promise.all([tooltip1, tooltip2, tooltip3, tooltip4]).then((res) => {
          if (res) {
            let tooltips = {}
            if (res[0].data.length) tooltips['122'] = res[0].data[0]
            if (res[1].data.length) tooltips['123'] = res[1].data[0]
            if (res[2].data.length) tooltips['124'] = res[2].data[0]
            if (res[3].data.length) tooltips['125'] = res[3].data[0]
            this.tooltipsObj = tooltips
          }
        })
      } catch (e) {

      }
    },
    // 获取金刚位banner
    getGoodLocaltion() {
      let location1 = api.jobs.getBannerImg({position: 118})
      let location2 = api.jobs.getBannerImg({position: 119})
      let location3 = api.jobs.getBannerImg({position: 120})
      let location4 = api.jobs.getBannerImg({position: 121})
      Promise.all([location1, location2, location3, location4]).then((res) => {
        if (res) {
          if (res[0].data.length) {
            this.iconList.push({ tooltipsKey: '122', ...res[0].data[0]})
          }
          if (res[1].data.length) {
            this.iconList.push({ tooltipsKey: '123', ...res[1].data[0]})
          }
          if (res[2].data.length) {
            this.iconList.push({ tooltipsKey: '124', ...res[2].data[0]})
          }
          if (res[3].data.length) {
            this.iconList.push({ tooltipsKey: '125', ...res[3].data[0]})
          }
        }
      })
    },
    toLink(url) {
      if(url.search('/job/intentions') != -1 && !this.alreadyLogged) {
        this.needLogin()
      } else {
        window.location.href = url
      }
    }
  }
}
</script>

<style scoped lang="scss">
.location-body{
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #fff;
}
.location-item{
  position: relative;
  flex: 1;
  .icon-hot{
    position: absolute;
    width: 40px;
    height: 40px;
    top: -20px;
    right: 12px;
  }
  .location-icon{
    width: 48px;
    height: 48px;
    object-fit: contain;
    display: block;
    margin: auto;
    margin-bottom: 8px;
  }
  &>div{
    text-align: center;
    color: #404040;
    font-size: 13px;
    font-weight: 400;
  }
}
</style>
